<template>
  <div>
    <h2>
      Reporte de Aguinaldos
    </h2>
    <el-card class="box-card">
      <div slot="header" class="d-flex space-between">
        <h4>Filtros</h4>
        <el-button size="mini" plain @click="showFilters = !showFilters">
          <i v-if="!showFilters" class="icon el-icon-arrow-down "></i>
          <i v-if="showFilters" class="icon el-icon-arrow-up "></i>
        </el-button>
      </div>
      <el-row :gutter="10" v-if="showFilters">
        <el-col :md="6">
          <h5>Compañía</h5>
          <el-select :disabled="disableFilter" v-model="filters.company_id" placeholder="Selecciona una compañia" style="width: 100%;"
                     @change="getCompanyRelatedData()">
            <el-option
              v-for="item in companies"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="6">
          <h5>Centro de costo</h5>
          <el-select :disabled="disableFilter" v-model="filters.cost_centers_id" placeholder="Selecciona un centro de costo" style="width: 100%;"
                     multiple @change="getEmployeesData()">
            <el-option
              v-for="item in cost_centers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="6">
          <h5>Empleado</h5>
          <el-select :disabled="disableFilter" v-model="filters.employee_id" placeholder="Selecciona un empleado" style="width: 100%;"
                     multiple>
            <el-option
              v-for="item in employees"
              :key="item.id"
              :label="item.names +' '+ item.last_names"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="6">
          <h5>Periodo</h5>
          <el-select :disabled="disableFilter" :loading="load"  v-model="filters.periods" placeholder="Selecciona un Periodo" style="width: 100%;">
            <el-option
              v-for="item in periods"
              :key="item.year"
              :label="item.label"
              :value="item.year">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px">
        <el-col :md="12">
          <el-input placeholder="# Envio" v-model="filters.envio"
                    :min="0"
                    label="Envio"
                    style="width: 100%;">
          </el-input>
        </el-col>
        <el-col :md="12">
          <el-input placeholder="Concepto" v-model="filters.concept"
                    :min="0"
                    label="Concepto"
                    style="width: 100%;">
          </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="showFilters">
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px">
        <el-col :md="24">
          <el-button type="danger" @click="cleanFilters()" :loading="loading" plain>Borrar Filtros</el-button>
          <el-button type="primary" @click="disableFilters()" :loading="loading" plain>Buscar Aguinaldos</el-button>
          <el-button type="success" @click="exportReport()" :loading="exporting" plain>Exportar</el-button>
          <el-button type="primary" @click="exportENV()" :loading="exporting" plain>Exportar Nacional</el-button>
          <el-button type="danger" @click="exportPRN()" :loading="exporting" plain>Exportar Bac</el-button>
          <el-checkbox class="float-left" v-model="filters.active"><h5>Mostrar solo empleados activos</h5></el-checkbox>
        </el-col>
      </el-row>
    </el-card>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="employee_code"
          label="Cod">
        </el-table-column>
        <el-table-column
          prop="card"
          label="Identidad">
        </el-table-column>
        <el-table-column
          prop="names"
          label="Nombre">
          <template slot-scope="scope">
            <p>{{scope.row.names +' '+scope.row.last_names}}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="Compañía">
        </el-table-column>
        <el-table-column
          prop="name"
          label="Centro de costos">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="Total Aguinaldo">
        </el-table-column>
      </el-table>
    </app-table>
  </div>

</template>
<script>
  import AppTable from '../../components/Table'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import {baseApi} from '../../configs/urls'
  import {saveAs} from 'file-saver'
  import {params, parseError} from '../../packages/Helpers'

  export default {
    extends: BaseCrud,
    name: 'bonuses-report',
    components: {
      AppTable
    },
    data () {
      return {
        disableFilter: false,
        load: false,
        scope: null,
        bonusesData: [],
        cost_centers: [],
        companies: [],
        payrolls: [],
        bonuses: [],
        employees: [],
        periods: [],
        months: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Setiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ],
        filters: {
          periods: null,
          cost_centers_id: [],
          company_id: [],
          employee_id: []
        },
        dialogFormVisible: false,
        exporting: false,
        showFilters: true,
        methodForUpdate: 'post',
        baseUrl: baseApi + '/bonusesPaidDetails',
        companyUrl: baseApi + '/companies',
        yearsUrl: baseApi + '/years',
        bonusesUrl: baseApi + '/bonuses',
        costCentersUrl: baseApi + '/cost-centers',
        basePermission: 'employees',
        employeesURL: baseApi + '/employees',
        bonusesPaidDetailsURL: baseApi + '/bonusesPaidDetails'
      }
    },
    methods: {
      exportPRN () {
        const data = this.filters
        let url = baseApi + '/reports/bonusesPrn'
        this.exporting = true
        this.$http.post(url, data, {
          headers: {'Accept': 'text/plain'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'text/plain'})
              let filename = 'aguinaldos'
              saveAs(blob, filename + '.PRN')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      exportReport () {
        const data = this.filters
        let url = baseApi + '/reports/bonusesExcelRep'
        this.exporting = true
        this.$http.post(url, data, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              let filename = 'Reporte de Aguinaldos'
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      showTestKey (testKey) {
        this.$alert(`Se ha generado el archivo, para la confirmación necesitara el <br/><big><b> Test Key ${testKey}</b></big><br/>favor tomar nota de este codigo`, 'BTL VISOR', {
          confirmButtonText: 'Aceptar',
          dangerouslyUseHTMLString: true
        })
      },
      exportENV () {
        const data = this.filters
        let url = baseApi + '/reports/bonusesEnv'
        this.exporting = true
        this.$http.post(url, data, {
          headers: {'Accept': 'text/plain'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data.content], {type: 'application/octet-stream'})
              let filename = 'aguinaldos '

              saveAs(blob, filename + '.env')
              this.showTestKey(response.data.testKey)
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      companyData () {
        this.$http.get(this.companyUrl)
          .then(
            (res) => {
              this.companies = res.body
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
            }
          )
      },
      yearsData () {
        this.load = true
        this.$http.get(this.yearsUrl)
          .then(
            (res) => {
              this.periods = res.body
              this.load = false
            },
            (res) => {
              this.load = false
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
            }
          )
      },
      getCompanyRelatedData () {
        if (this.filters.company_id) {
          this.filters.cost_centers_id = []

          this.$http.get(this.costCentersUrl + '?company_id=' + this.filters.company_id)
            .then(
              (res) => {
                this.cost_centers = res.body
              },
              (res) => {
                if (res.status !== 0) {
                  this.$message.error(parseError(res)[0])
                }
              }
            )
          this.getEmployeesData()
        }
      },
      getEmployeesData () {
        if (this.filters.company_id > 0 && this.filters.cost_centers_id.length > 0) {
          const param = {
            company_id: this.filters.company_id,
            cost_centers: this.filters.cost_centers_id
          }
          this.$http.get(this.employeesURL + params(param))
            .then(
              (res) => {
                this.employees = res.body
              },
              (res) => {
                if (res.status !== 0) {
                  this.$message.error(parseError(res)[0])
                }
              }
            )
        }
      },
      cleanFilters () {
        this.disableFilter = false
        this.filters = {
          periods: (new Date().getFullYear()),
          cost_centers_id: [],
          company_id: null,
          employee_id: []
        }
        this.refreshData()
      },
      disableFilters () {
        this.disableFilter = true
        this.refreshData()
      },
      storeData () {
        let filters = {
          employee_id: this.filters.employee_id,
          cost_center_id: this.filters.cost_centers_id,
          company_id: this.filters.company_id,
          year: this.filters.periods
        }
        this.$http.post(this.baseUrl, filters)
          .then(
            () => {
              this.refreshData()
            },
            (res) => {
              this.showErrors(res)
            }
          )
      },
      showBonusesDialog (scope) {
        let period1 = ''
        let period2 = ''
        console.log(this.filters.periods + this.filters.periods + ' pablo')
        const yearSelected = Number(this.filters.periods)
        period1 = (yearSelected - 1) + '-12-01'
        period2 = yearSelected + '-11-30'

        const param = {
          pagination: 0,
          employee_id: scope.row.employee_id,
          period1: period1,
          period2: period2
        }
        this.bonusesData = []
        this.$http.get(this.bonusesDetailsURL + params(param))
          .then(
            (res) => {
              for (let key of res.body) {
                key.month = this.months[key.month - 1]
                key.month += ' ' + key.year
              }
              this.bonusesData = res.body
              console.log(this.bonusesData)
            },
            (res) => {
              if (res.status !== 0) {
                this.$message.error(parseError(res)[0])
              }
            }
          )
        this.scope = scope.row

        this.dialogFormVisible = true
      },
      _beforeRefresh (params) {
        params.employee_id = this.filters.employee_id
        params.cost_center_id = this.filters.cost_centers_id
        params.company_id = this.filters.company_id
        params.year = this.filters.periods
      }
    },
    mounted () {
      this.companyData()
      this.yearsData()
    }
  }
</script>
<style>
  .float-left {
    float: right;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/reports/BonusesReport.vue